import React from 'react';
import * as styles from './StatsList.style';

export interface StatsListItem {
  value: string,
  label: string,
}

export interface StatsListProps {
  items: StatsListItem[],
  itemsInline?: number,
}

const StatsList: React.FC<StatsListProps> = ({
  items,
  itemsInline = 3,
}) => (
  <div css={styles.base}>
    {items.map((item) => (
      <div
        key={item.value}
        css={styles.item}
        $count={itemsInline}
      >
        <div css={styles.box}>
          <div css={styles.value}>
            {item.value}
          </div>
          <div css={styles.label} dangerouslySetInnerHTML={{ __html: item.label }} />
        </div>
      </div>
    ))}
  </div>
);

export default StatsList;
